<template>
  <el-drawer
    :style="{top: top,pointerEvents:'none'}"
    :visible.sync="dwVisible"
    :show-close="false"
    :size="size"
    :wrapper-closable="modal"
    :modal-append-to-body="modalAppendToBody"
    :with-header="false"
    :modal="hasModal"
    @close="ddtCloseBefore">
    <div class="ddt-wrap" :style="ddtWrapStyleObj">
      <slot name="title">
        <div class="ddt-title" v-if="title">
          <div class="tit">{{title}}</div>
          <i class="close el-icon-close" v-if="close" @click="ddtClose"></i>
        </div>
      </slot>
      <div class="ddt-main">
        <slot></slot>
      </div>
      <slot name="footer"></slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'kyDialogdrawerdefect',
  props: {
    ddtvisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    modal: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '50px'
    },
    size: {
      type: String,
      default: '500px'
    },
    close: {
      type: Boolean,
      default: false
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    hasModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dwVisible: {
      get() {
        return this.ddtvisible
      },
      set(val) {
        this.$emit('update:ddtvisible', val)
      }
    },
    // 距离顶部的距离计算
    ddtWrapStyleObj() {
      if (this.top) {
        return {
          height: `calc(100vh - ${this.top})`
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    // 遮罩层点击
    ddtCloseBefore() {
    //   if (!this.dwVisible) {
      this.$emit('close')
    //   }
    },
    // 关闭弹框
    ddtClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ddt-wrap{
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  box-sizing: border-box;
  right: 0;
  bottom: 0;
  z-index: 101;
  display: flex;
  flex-direction: column;
  pointer-events: all;
}
.ddt-title{
  display: flex;
  align-items: center;
  padding: 15px;
  width: 100%;
  line-height: 18px;
  font-size: 16px;
  border-bottom: 1px solid #E5E7EC;
  .tit{
    flex: 1;
  }
  .close{
    font-size: 18px;
    color: #666;
    cursor: pointer;
    &:hover{
      opacity: #333;
    }
  }
}
.ddt-main{
  flex: 1;
  overflow-y: auto;
  pointer-events: all;
//   height: 100%;
  border-left: 1px solid #e5e5e5;
  padding: 0px 24px;
  color: #606266;
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// packages/dialogdrawerdefect/dialogDrawerDefect.vue